import { EducationTooltip } from '@driftt/tide-tooltips-legacy'
import cx from 'classnames'
import { UpgradeModal } from '@driftt/billing-components'
import Toggle from 'components/Toggle'
import EmailTemplateModal from 'components/EmailTemplateModal'
import { humanizeDelay } from 'components/EmailTemplateModal/utils'

const MeetingEmailSettings = ({
  confirmationEmailStatus,
  reminderEmailStatus,
  toggleMeetingConfirmationStatus,
  toggleMeetingReminderStatus,
  confirmationDelayTime,
  reminderDelayTime,
  reminderFollowUpDelayTime,
  confirmationModal,
  reminderModal,
  toggleModal,
  gatedModal,
  hasProPlan,
  seenPersonalizationEmailEducation,
  actions,
  meetingSettings,
  toggleMeetingManagement,
}) => {
  const { allowMeetingManagement = false } = meetingSettings
  return <div>
    <div className="toggle-setting">
      <div className="subheader meeting-management-subheader">
        <div className="flex">Allow guests to cancel or reschedule their meeting</div>
      </div>
      <div className="copy-and-toggle">
        <p className="settings-body-copy">
          Add links to your meeting invites so guests can reschedule or cancel meetings on their own.
        </p>
        <div className="drift-form">
          <Toggle checked={!!allowMeetingManagement} onChange={toggleMeetingManagement} />
        </div>
      </div>
    </div>
    <EducationTooltip
      className="meeting-personalization-education-tooltip"
      onClose={() => actions.openedMeetingEmailModal()}
      showTooltip={!seenPersonalizationEmailEducation}
      ribbonInfo={{ ribbonCopy: 'New!', ribbonColor: 'var(--main-violet)' }}
      tooltipSide="top"
      tooltipCaretLocation="center"
      headerCopy="Try personalizing your meeting emails"
      bodyCopy="You can now customize the emails that get automatically sent when someone books a meeting with you."
      buttonInfoArray={[
        {
          copy: 'Personalize my confirmation Email',
          func: () => {
            actions.openedMeetingEmailModal()
            toggleModal('confirmationModal', true)
          },
        }
      ]}>
    </EducationTooltip>
    <div className="toggle-setting">
      <EmailTemplateModal isOpen={confirmationModal}
        settingName="MEETING_CONFIRMATION"
        onClose={() => toggleModal('confirmationModal', false)}/>
      <div className="subheader meeting-management-subheader">
        <div className="flex">Send a confirmation email when a meeting is booked</div>
      </div>
      <div className="copy-and-toggle">
        <p className="settings-body-copy">
          Your Drift Assistant will send a personalized email to your guest {humanizeDelay(confirmationDelayTime)} after they book a meeting.&nbsp;
          <a onClick={() => {
            actions.openedMeetingEmailModal()
            toggleModal('confirmationModal', true)
          }}>Customize</a>
        </p>
        <div className="drift-form">
          <Toggle checked={!!confirmationEmailStatus} onChange={toggleMeetingConfirmationStatus} />
        </div>
      </div>
    </div>
    <div className={cx("toggle-setting", { gated: !hasProPlan })} onClick={() => {
      !hasProPlan && toggleModal('gatedModal', true)
    }}>
      <EmailTemplateModal isOpen={reminderModal}
        settingName="MEETING_REMINDER"
        settingTemplateOptions={['MEETING_REMINDER', 'MEETING_REMINDER_FOLLOW']}
        onClose={() => toggleModal('reminderModal', false)}/>
      <div className="subheader meeting-management-subheader">
        <div className="flex">Send a reminder email to guests before a meeting</div>
      </div>
      <div className="copy-and-toggle">
        <p className="settings-body-copy">
          {
            hasProPlan
            ? `To help reduce no shows, your Drift Assistant will send a personalized email to your guest ${humanizeDelay(reminderDelayTime)} and ${humanizeDelay(reminderFollowUpDelayTime)} before their meeting with you. `
            : "To help reduce no shows, your Drift Assistant can automatically send personalized email reminders to your guests before your meeting."
          }
          {hasProPlan && <a onClick={() => {
            actions.openedMeetingEmailModal()
            toggleModal('reminderModal', true)
          }}>Customize</a>}
        </p>
        <div className="drift-form">
          {hasProPlan && <Toggle checked={!!reminderEmailStatus} onChange={toggleMeetingReminderStatus} /> }
        </div>
      </div>
      { !hasProPlan && <div className="PremiumOverlay__Banner">Upgrade</div>}
      { !hasProPlan && gatedModal && (
        <UpgradeModal
          onCloseInitiated={() => toggleModal('gatedModal', false)}
          headLineFeatureText={'Automated Meeting Reminders'}
          planName={'Pro'}
          isMonthlyBilling={true}
        />
      )}
    </div>
  </div>
}

export default MeetingEmailSettings



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/MeetingEmailSettings/component.js